export const messages = {
    "shared-link.footer.link.install": "Prøv {brandName} gratis",
    "shared-link.footer.link.mobile": "{brandName} for mobil",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Beskyttede data",
    "shared-link.password-dialog-box.message": "Spesifiser passordet for å få tilgang til de delte dataene",
    "shared-link.password-dialog-box.hint.password": "Passord",
    "shared-link.password-dialog-box.message.invalid-password": "Passordet er feil",
    "shared-link.form.button.open": "Åpne",
    "shared-link.page-not-found.title": "Fant ikke siden",
    "shared-link.page-not-found.message.main": "Fant ikke siden du så etter.",
    "shared-link.page-not-found.message.description": "Koblingen kan være utdatert, eller du kan ha skrevet inn feil adresse.",
    "shared-link.page-not-found.message.error": "Feilkode: 404",
    "shared-link.restore-file.label.size": "Størrelse",
    "shared-link.restore-file.button.restore": "Last ned",
    "shared-link.links-table.column.name": "Navn",
    "shared-link.links-table.column.size": "Størrelse",
    "shared-link.links-table.action.restore": "Last ned",
    "shared-link.links-table.action.restore-all": "Last ned alle",
    "shared-link.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "shared-link.links-table.label.size": "Størrelse",
    "shared-link.links-table.message.empty-folder": "Denne mappen er tom"
};
